import { Container } from 'react-bootstrap'
import '../../assets/scss/page-high-gain/index.scss'
import '../../assets/scss/home/promotion.scss'
import Selling from './Selling'
import SoldOut from './SoldOut'
import MetaTagHeader from './MetaTagHeader'
import { useEffect, useState } from 'react'
import { useApolloClient } from '@apollo/react-hooks'
import { QUERY_OFFER_LIST } from '../../queries/offer'
import get from 'lodash.get'
import { useTranslation } from 'react-i18next'
import Loading from '../Loading'
import styled from 'styled-components'

const MyContainer = styled(Container)`
  padding-top: 64px;
  .promotion__slider-container {
    background: #f9fafc;
  }
`

const PageHighGain = () => {
  const [t] = useTranslation()
  const client = useApolloClient()
  const [openingOffer, setOffers] = useState([])
  const [closedOffer, setClosedOffers] = useState([])
  const [loading, setLoading] = useState(true)
  const fetchOffers = async (filters) => {
    try {
      const { data } = await client.query({
        query: QUERY_OFFER_LIST,
        fetchPolicy: 'no-cache',
        variables: {
          page: 1,
          limit: 50,
          filter: {
            ...filters,
            currency: 'VND',
            country: 'VN',
          },
        },
      })
      if (filters.soldout === false) {
        setOffers(get(data, 'primary_sell_offers.docs'))
      } else {
        setClosedOffers(get(data, 'primary_sell_offers.docs'))
      }

    } catch (ex) {
      //
    }
    setLoading(false)
  }

  useEffect(() => {
    const openningFilter = {
      statuses: ["started"],
      soldout: false,
    }
    const closedFilter = {
      soldout: true,
    }
    fetchOffers(openningFilter)
    fetchOffers(closedFilter)
  }, [])

  return (
    <MyContainer fluid className="properties-conatiner">
      {loading ? (
        <div className="flex" style={{ height: 'calc(100vh)' }}>
          <Loading width={70} />
        </div>
      ) : (
        <>
          <Container>
            <MetaTagHeader />
            <Selling title={t`Dự án đang mở đầu tư`} openingOffers={openingOffer} />
            <SoldOut offers={closedOffer} />
          </Container>
        </>
      )}
    </MyContainer>
  )
}

export default PageHighGain
